import { ROLE_IDS, USER_ROLES } from '../constants/roles';

const getRoleId = (roleItem) => {
    if (roleItem == null) {
        return null;
    }

    if (typeof roleItem === 'number') {
        return roleItem;
    }

    const id = roleItem?.role_id ?? roleItem?.roleId ?? roleItem?.id;
    return id != null ? Number(id) : null;
};

const getRoleName = (roleItem) => {
    if (typeof roleItem === 'string') {
        return roleItem;
    }

    return roleItem?.role_name ?? roleItem?.roleName ?? roleItem?.name ?? null;
};

const matchesRoleKey = (roleItem, roleKey) => {
    const id = getRoleId(roleItem);
    const name = getRoleName(roleItem);

    if (roleKey === USER_ROLES.ADMIN) {
        return id === ROLE_IDS.ADMIN || name === USER_ROLES.ADMIN || name === 'Администратор';
    }

    if (roleKey === USER_ROLES.EMPLOYEE) {
        return id === ROLE_IDS.EMPLOYEE || name === USER_ROLES.EMPLOYEE || name === 'Сотрудник';
    }

    return name === roleKey || id === roleKey;
};

const normalizeUserRoles = (userLike) => {
    if (!userLike) {
        return [];
    }

    if (Array.isArray(userLike.roles) && userLike.roles.length) {
        return userLike.roles;
    }

    const roleId = userLike.role_id ?? userLike.roleId;
    const roleName = userLike.role_name ?? userLike.roleName ?? userLike.role;

    if (roleId != null || roleName != null) {
        return [{ role_id: roleId, role_name: roleName }];
    }

    return [];
};

const userHasRole = (user, roleKey) => {
    const roles = normalizeUserRoles(user);
    if (!roles.length) {
        return false;
    }

    return roles.some((roleItem) => matchesRoleKey(roleItem, roleKey));
};

export const isAdminRoleChecker = (user, role) => userHasRole(user, role);

export const isEmployeeRoleChecker = (user) => userHasRole(user, USER_ROLES.EMPLOYEE);

/** Панель администратора и «Пользователи ЛК». Администратору роль Employee не нужна. */
export const isStaffRoleChecker = (user) => {
    return userHasRole(user, USER_ROLES.ADMIN) || userHasRole(user, USER_ROLES.EMPLOYEE);
};

/** Имперсонация недоступна для администраторов и сотрудников. */
export const canImpersonateTargetUser = (userLike) => {
    return !isStaffRoleChecker(userLike);
};

/** Подсказка, почему нельзя войти под пользователем (админ / сотрудник). */
export const getImpersonationBlockedHint = (userLike) => {
    if (isAdminRoleChecker(userLike, USER_ROLES.ADMIN)) {
        return 'Пользователь является администратором. Вход под его учётной записью недоступен.';
    }
    if (isEmployeeRoleChecker(userLike)) {
        return 'Пользователь является сотрудником. Вход под его учётной записью недоступен.';
    }
    return 'Вход под этой учётной записью недоступен.';
};
